<!--- FORMULARIO Gestionar lineas de producción  ---->
<!---
CASO DE USO: https://grupohispatec.sharepoint.com/:w:/s/Produccin/EQGVtEI-QZBGn5mlWlmWKuoBpbhZcHXi7Y9UhT25hgCQpQ?e=keizgg
Descripción del formulario:
---------------------------
- Formulario donde se permite planificar los pedidos de venta en puntos de paletizado.
--->

<template>
  <f7-page class="main-gestionlineaproduccion">
    <div class="content-menu">
      <PCSideNavbar />
    </div>
    <div class="content-data padding-half">
      <div class="content-header padding-bottom-half">
        <div class="content-header__actions">
          <div
            v-if="lineaSeleccionada != null
              && numberIncidences > 0"
            class="content-header__actions--button margin-left"
            @click="popupIncidenciasPedidos = true"
          >
            <span>
              {{ $t('common.incidents') }}
            </span>

            <span
              class="badge badge-indicadorActualizacionAPP"
            >{{
              numberIncidences
            }}</span>
          </div>
          <div
            class="content-header__actions--button margin-left"
            :class="{
              'div-elementoTarjetaLineaDeshabilitada': contadorDeLlamadasPendientesDeRespuestaEnFrm !== 0 || !lineaSeleccionada,
            }"
            @click="ActualizarPedidosPenditesDePlanificarYPlanificadosLinea({ resetFilters: true })"
          >
            <img
              alt="iconUpdate"
              src="@/static/img/ic_update.svg"
            >
            <span>
              {{ $t('production.manageProductionLines.header.refresh') }}
            </span>
          </div>
          <!-- <UCLineasDeProduccion
            :valor-por-defecto="lineaSeleccionadaAlIniciarFormulario"
            plantilla="P2"
            :mostrar-titulo="false"
            :deshabilitar-controles-de-avance-y-retroceso="
              contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true
            "
            @lineaProduccionSeleccionada="LineaProduccionSeleccionada"
          /> -->
          <div class="margin-left margin-right line-production">
            <UCSearchEntityERP
              :placeholder="$t('common.productionLine')"
              :search-text="$t('searchEntity.line.searchText')"
              :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
              :default-value="lineaSeleccionadaAlIniciarFormulario"
              :default-etities-list="lineasProduccion"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm === 0 ? false : true"
              :next-and-previous-buttons-shown="true"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :emit-evet-change-default-value="true"
              @selection="LineaProduccionSeleccionada"
            />
          </div>
        </div>
        <div class="content-header__logo margin-left">
          <img
            v-if="logoApp"
            id="logo"
            alt="logoCliente"
            :src="logoApp"
          >
          <img
            v-else
            id="logo"
            alt="logoHispatec"
            :src="LOGO_HISPATEC"
          >
        </div>
      </div>
      <f7-row style="align-items: normal;">
        <f7-col
          width="20"
          class="paletizado-points"
        >
          <!-- <span class="span-tituloColumnas no-seleccionable">PUNTOS DE PALETIZADO</span> -->
          <div class="paletizado-points__results">
            <div
              v-for="punto in puntosDePaletizado"
              :key="punto.Id"
              class="div-elementoTarjetaLinea seleccionable"
              :class="{
                'div-elementoTarjetaLineaSeleccionada': punto === puntoDePaletizadoSeleccionado ? true : false,
                'div-elementoTarjetaLineaDeshabilitada':
                  contadorDeLlamadasPendientesDeRespuestaEnFrm !== 0 && punto !== puntoDePaletizadoSeleccionado
                    ? true
                    : false,
              }"
              @click="PuntoDePaletizadoSeleccionado(punto)"
            >
              {{ punto.Nombre }}

              <PCOperacionesPersonalizadas
                v-if="personalizacionPuntoPalrtizadoActiva && puntoDePaletizadoSeleccionado != null && punto.Id === puntoDePaletizadoSeleccionado.Id"
                :app-theme="appTheme"
                :tipo-entidad="0"
                :entidad="puntoDePaletizadoSeleccionado"
                :parametros="[puntoDePaletizadoSeleccionado.Id]"
                formulario-padre="frmGestionLineaProduccion"
                componente-aplicacion="PCSelectorPuntoPaletizado"
                :mostrar-precarga="false"
              />
            </div>
          </div>
        </f7-col>
        <f7-col
          width="25"
          class="content-planned"
        >
          <div class="content-planned__title">
            {{ $t('production.manageProductionLines.sections.planned.title').toUpperCase() }}
          </div>
          <div class="content-planned__results padding-top padding-horizontal-half">
            <UCPreload :show="mostrarPrecargaPedidosPlanificados" />
            <VueDraggableNext
              :list="listadoPedidosPlanificados"
              group="pedidos"
              handle=".handle"
              :options="dragOptions"
              @change="CambioRealizadoEnListadoPedidosPlanificados"
            >
              <div
                v-for="(pedido, index) in listadoPedidosPlanificados"
                :key="index"
                class="no-seleccionable content-card padding-bottom-half"
                :class="{
                  'no-movible': Serfruit.EsSerfruit && Serfruit.DesplanificarSerfruit,
                  'movible': !Serfruit.EsSerfruit || Serfruit.EsSerfruit && !Serfruit.DesplanificarSerfruit,
                }"
                @click="ComprobarAlEliminar"
              >
                <div class="content-card__title padding-left-half">
                  <div class="content-card__title--info">
                    <img
                      v-if="pedido.MensajesInformacion.length > 0"
                      alt="iconWrning"
                      src="@/static/icons/ic_warning.svg"
                    >
                    <img
                      v-if="pedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado === 0"
                      alt="iconEclipseOrange"
                      src="@/static/img/ic_elipse_orange.svg"
                    >
                    <img
                      v-if="pedido.TipoEstado === 1"
                      alt="iconEclipseGreen"
                      src="@/static/img/ic_elipse_green.svg"
                    >
                    <span>
                      {{ `${pedido.Pedido}-${pedido.Orden} ${FormatearCadena(pedido.NombreCliente, 30)}` }}
                    </span>
                  </div>
                  <div class="content-card__title--action">
                    <img
                      v-if="pedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado !== 0 && pedido.TipoEstado !== 1 && (!Serfruit.EsSerfruit || !Serfruit.EsPlanificada || pedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado !== Serfruit.IdEntidad)"
                      src="@/static/img/ic_card_action.svg"
                      alt="iconAction"
                      class="handle seleccionable"
                      :class="{ deshabilitado: contadorDeLlamadasPendientesDeRespuestaEnFrm !== 0 }"
                    >
                  </div>
                </div>
                <div class="content-card__info padding-half">
                  <div class="card-info-content-title">
                    <div class="card-info-content-title__title">
                      {{ pedido.Producto.Nombre }}
                    </div>
                    <div class="card-info-content-title__after">
                      <f7-badge color="gray">
                        {{ pedido.Prioridad }}
                      </f7-badge>
                      <img
                        src="@/static/img/ic_settings_gray.svg"
                        alt="iconSettingGray"
                        width="30"
                        height="30"
                        @click="AbrirFormularioEdicionDePedidoPlanificado(pedido)"
                      >
                    </div>
                  </div>
                  <div class="card-info-content-subtitle">
                    {{ pedido.Envase.Nombre }}
                  </div>
                  <div class="card-info-content-text">
                    {{ `${$t('common.alias')}: ${FormatearCadena(pedido.AliasCliente, 26)}` }}

                    <PCOperacionesPersonalizadas
                      v-if="personalizacionPCTarjetaPlanificacionActiva"
                      :entidad="{ Id: pedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado }"
                      :parametros="[pedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado]"
                      :tipo-entidad="0"
                      formulario-padre="frmGestionLineaProduccion"
                      componente-aplicacion="PCPedidosPlanificados"
                      :modo-consulta-agrupada="true"
                      :datos="datosLineasPedidoPlanificadasParaPersonalizaciones"
                      :mostrar-precarga="false"
                      @action-end="ActualizarPedidosPenditesDePlanificarYPlanificadosLinea"
                    />
                  </div>
                  <div class="card-info-content-footer">
                    <div class="card-info-content-footer__ref">
                      {{ `${$t('common.referenceShort')} ${FormatearCadena(pedido.ReferenciaPedidoVenta, 15)}` }}
                    </div>
                    <div class="card-info-content-footer__items">
                      <div>
                        <span
                          v-if="Serfruit.EsSerfruit "
                          id="cantidad-palet"
                        >
                          {{ `${(pedido.CantidadPalesTotalesDeLaLineaPedido - pedido.CantidadPalet)} ${$t('common.of')} ${pedido.CantidadPalesTotalesDeLaLineaPedido}` }}
                        </span>
                        <span v-else>{{ pedido.CantidadPalet }}</span>
                        <img
                          width="26px"
                          alt="iconPale"
                          src="@/static/icons/ic_palet.svg"
                        >
                      </div>
                      <div class="padding-left">
                        <span>{{ pedido.CantidadEnvasesPorPalet * pedido.CantidadPalet }}</span>
                        <img
                          width="26px"
                          alt="iconBox"
                          src="@/static/icons/ic_box.svg"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VueDraggableNext>
          </div>
        </f7-col>
        <f7-col
          width="55"
          class="content-pending padding-bottom-half"
        >
          <div class="content-pending__title">
            <span>
              {{ $t('production.manageProductionLines.sections.pending.title').toUpperCase() }}
            </span>
            <f7-button
              v-if="permitirCrearOrdenYParteDeProduccionPorPedidoEnMovilidad"
              class="content-pending__title--button"
              @click="SeleccionarPedido"
            >
              {{ $t('production.manageProductionLines.sections.pending.btnSelectOrderText') }}
            </f7-button>
          </div>

          <div class="content-filters padding-horizontal-half padding-vertical-half">
            <UCDatePicker
              id="1"
              ref="UCDatePicker"
              class="date-search"
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm > 0"
              :init-null="true"
              :default-value="null"
              :range-picker="true"
              date-format="dd/mm"
              @onchange="ChangedDateQuery"
            />
            <UCSearchEntityERP
              ref="UCClientComponent"
              :placeholder="$t('common.customer')"
              :search-text="$t('searchEntity.client.searchText')"
              :search-cancellation-text="$t('searchEntity.client.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.client.searchNotFoundText')"
              :property-entity-shown-input="['NombreCliente']"
              :property-entity-shown-list-title="['NombreCliente']"
              :next-and-previous-buttons-shown="false"
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm > 0"
              :input-read-only="true"
              :default-etities-list="filtroCliente"
              @selection="EventClientSelected"
            />
            <UCSearchEntityERP
              ref="UCreferenciasComponent"
              :placeholder="$t('common.references')"
              :search-text="$t('searchEntity.reference.searchText')"
              :search-cancellation-text="$t('searchEntity.reference.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.reference.searchNotFoundText')"
              :property-entity-shown-input="['ReferenciaPedidoVenta']"
              :property-entity-shown-list-title="['ReferenciaPedidoVenta']"
              :next-and-previous-buttons-shown="false"
              :disabled="contadorDeLlamadasPendientesDeRespuestaEnFrm > 0"
              :input-read-only="true"
              :default-etities-list="filtroReference"
              @selection="EventReferenceSelected"
            />
          </div>
          <div class="content-pending__results">
            <UCPreload
              :show="mostrarPrecargaPedidosPendientesPlanificar"
            />
            <!-- <pre>{{listadoPedidosPendientes}}</pre> -->
            <VueDraggableNext
              :list="listaFiltros"
              group="pedidos"
              handle=".handle"
              class="padding-horizontal-half"
              @change="CambioRealizadoEnListadoPedidosPendientesDePlanificar"
            >
              <div
                v-for="(pedido, index) in listaFiltros"
                :key="index"
                class="content-card no-seleccionable padding-bottom-half"
              >
                <div class="content-card__title padding-left-half">
                  <div class="content-card__title-left">
                    <img
                      v-if="pedido.MensajesInformacion.length > 0"
                      alt="iconWarning"
                      src="@/static/icons/ic_warning.svg"
                    >
                    <span>
                      {{ `${pedido.Pedido}-${pedido.Orden} ${FormatearCadena(pedido.NombreCliente, 30)}` }}
                    </span>
                  </div>
                  <div class="content-card__title-right">
                    <div
                      v-if="pedido.Dividido"
                      class="div-rectanguloPedidoDivido"
                    >
                      <span>
                        {{ $t('production.manageProductionLines.orderCard.divided') }}
                      </span>
                    </div>
                    <div class="content-card__title--action">
                      <img
                        src="@/static/img/ic_card_action.svg"
                        alt="iconCardAction"
                        class="handle seleccionable"
                        :class="{ deshabilitado: contadorDeLlamadasPendientesDeRespuestaEnFrm !== 0 ? true : false }"
                      >
                    </div>
                  </div>
                </div>
                <div class="content-card__info padding-half">
                  <div class="card-info-content-title">
                    <div class="card-info-content-title__title">
                      {{ pedido.Producto.Nombre }}
                    </div>
                    <div class="card-info-content-title__after">
                      <f7-badge color="gray">
                        {{ pedido.Prioridad }}
                      </f7-badge>
                      <img
                        src="@/static/img/ic_settings_gray.svg"
                        alt="iconSettingGray"
                        width="28"
                        height="28"
                        @click="AbrirFormularioEdicionDePedidoNoPlanificado(pedido)"
                      >
                    </div>
                  </div>
                  <div class="card-info-content-subtitle">
                    {{ pedido.Envase.Nombre }}
                  </div>
                  <div class="card-info-content-text">
                    {{ `${$t('common.alias')}: ${FormatearCadena(pedido.AliasCliente, 26)}` }}

                    <PCOperacionesPersonalizadas
                      v-if="personalizacionPCTarjetaPendientePlanificacionActiva"
                      :entidad="{ Id: pedido.ParteProduccionPrevistoSalida.Id }"
                      :tipo-entidad="0"
                      formulario-padre="frmGestionLineaProduccion"
                      componente-aplicacion="PCPedidosPendientesDePlanificar"
                      :modo-consulta-agrupada="true"
                      :datos="datosLineasPedidoPendientesPlanificarParaPersonalizaciones"
                      :mostrar-precarga="false"
                    />
                  </div>
                  <div class="card-info-content-footer">
                    <div class="card-info-content-footer__ref">
                      {{ `${$t('common.referenceShort')} ${FormatearCadena(pedido.ReferenciaPedidoVenta, 18)}` }}
                    </div>
                    <div class="card-info-content-footer__items">
                      <div>
                        <span>{{ pedido.CantidadPalet }}</span>
                        <img
                          alt="iconPalet"
                          width="26px"
                          src="@/static/icons/ic_palet.svg"
                        >
                      </div>
                      <div class="padding-left">
                        <span>{{ pedido.CantidadEnvasesPorPalet * pedido.CantidadPalet }}</span>
                        <img
                          width="26px"
                          alt="iconBox"
                          src="@/static/icons/ic_box.svg"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre> {{ listaFiltros }} </pre> -->
            </VueDraggableNext>
          </div>
        </f7-col>
      </f7-row>
    </div>
    <!-- Popup Edición de Pedido -->
    <f7-popup
      class="popupEdicionPedido-popup"
      :opened="popupEdicionPedidoAbierto"
      @popup:closed="popupEdicionPedidoAbierto = false"
    >
      <f7-page>
        <f7-navbar
          :title="$t('production.common.salesOrderDetail')"
          sliding
          :style="appTheme"
        >
          <f7-nav-right>
            <f7-link
              class="padding-right-half"
              @click="popupEdicionPedidoAbierto = false"
            >
              <img
                alt="iconClose"
                src="@/static/icons/ic_close.svg"
              >
            </f7-link>
          </f7-nav-right>
        </f7-navbar>

        <div
          v-if="popupEdicionPedidoAbierto"
          class="content-popup"
        >
          <PCMensajesInformativosPlanificacion
            v-if="pedidoSeleccionado.MensajesInformacion != null && pedidoSeleccionado.MensajesInformacion.length > 0"
            :mensajes-informacion="pedidoSeleccionado.MensajesInformacion"
          />
          <div class="div-contenidoFrmPopup">
            <!-- Cabecera Pedido -->
            <div
              v-if="pedidoSeleccionado != null"
              class="padding-half"
            >
              <div class="content-card margin-bottom-half">
                <div class="content-card__title padding-vertical-half padding-horizontal">
                  <div class="content-card__title--info">
                    {{ `${$t('common.salesOrderShort').toUpperCase()}: ${pedidoSeleccionado.Pedido} ${pedidoSeleccionado.NombreCliente}` }}
                  </div>
                </div>
                <div class="content-card__info padding">
                  <div class="card-info-content-title">
                    <div class="card-info-content-title__title">
                      {{ pedidoSeleccionado.Producto.Nombre }}
                    </div>
                  </div>
                  <div class="card-info-content-subtitle">
                    {{ pedidoSeleccionado.Envase.Nombre }}
                  </div>
                  <div class="card-info-content-text">
                    {{ `${pedidoSeleccionado.Pale.Codigo}-${FormatearCadena(pedidoSeleccionado.Pale.Nombre, 50)}` }}
                  </div>
                  <div class="card-info-content-footer">
                    <div class="card-info-content-footer__items">
                      <div>
                        <img
                          width="26"
                          alt="iconPalet"
                          src="@/static/icons/ic_palet.svg"
                        >
                        <span>
                          {{ `${pedidoSeleccionado.CantidadPalet} ${$t('common.pallets').toLowerCase()}` }}
                        </span>
                      </div>
                      <div>
                        <img
                          width="26"
                          alt="iconBox"
                          src="@/static/icons/ic_box.svg"
                        >
                        <span>
                          {{ `${(pedidoSeleccionado.CantidadEnvasesPorPalet * pedidoSeleccionado.CantidadPalet)} ${$t('common.packages').toLowerCase()}` }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-------------------- - DATOS COMPLEMENTARIOS - ------------------------>
              <f7-list
                v-if="datosComplementariosAObtener"
                accordion-list
                inset
                class="no-margin-horizontal margin-top-half no-margin-bottom content-accordion"
              >
                <f7-list-item
                  accordion-item
                  class="accordion-item-opened"
                  :title="$t('common.supplementaryData').toUpperCase()"
                >
                  <f7-accordion-content>
                    <UCSupplementaryData
                      :activo="popupEdicionPedidoAbierto"
                      :entidad-seleccionada="{ Id: pedidoSeleccionado.IdLineaPedidoVenta }"
                      tipo-entidad-seleccionada="LineaPedidoVenta"
                    />
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>

              <!-------------------- - OTROS DATOS - ------------------------>
              <f7-list
                accordion-list
                inset
                class="no-margin-horizontal margin-top-half no-margin-bottom content-accordion"
              >
                <f7-list-item
                  accordion-item
                  class="accordion-item-opened"
                  :title="$t('common.otherDataPl').toUpperCase()"
                >
                  <f7-accordion-content>
                    <PCDetalleLineaPedidoVenta
                      v-if="pedidoSeleccionado != null"
                      :pedido-seleccionado="pedidoSeleccionado"
                      :elementos-mostrar="[
                        'ObservacionesPedidoVenta',
                        'ObservacionesLineaPedidoVenta',
                        'ObservacionesPorte',
                        'Lote',
                        'AliasCliente',
                        'FechaSalida',
                        'FechaEntrega',
                        'Marca',
                        'OrdenProduccion',
                      ]"
                    />
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>

              <!-- Datos Adjuntos -->
              <f7-list
                accordion-list
                inset
                class="no-margin-horizontal margin-top-half no-margin-bottom content-accordion"
              >
                <f7-list-item
                  accordion-item
                  class="accordion-item-opened"
                  :title="$t('production.manageProductionLines.orderDetailsPopup.attachmentsData.title').toUpperCase()"
                >
                  <f7-accordion-content>
                    <PCDatosAdjuntosEntidad
                      v-if="pedidoSeleccionado != null"
                      class="componenteDatosAdjuntosEntidad"
                      :show-title="false"
                      :is-active="popupEdicionPedidoAbierto"
                      :entity-id="pedidoSeleccionado.IdPedidoVenta"
                      entity-type="PedidoVenta"
                    />
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>

              <!-- Operaciones -->
              <f7-list
                v-if="!pedidoSeleccionadoEstaPlanificado"
                accordion-list
                inset
                class="no-margin-horizontal margin-top-half no-margin-bottom content-accordion"
              >
                <f7-list-item
                  accordion-item
                  class="accordion-item-opened"
                  :title="$t('common.operations').toUpperCase()"
                >
                  <f7-accordion-content>
                    <div class="content-detail-actions padding">
                      <div class="content-stepper">
                        <span>
                          {{ $t('production.manageProductionLines.orderDetailsPopup.operations.divideOrder') }}
                        </span>
                        <f7-stepper
                          large
                          fill
                          :min="1"
                          :max="pedidoSeleccionado.CantidadPalet"
                          :value="pedidoSeleccionado.CantidadPalet"
                          @input="valorNuevaCantidadPaletParaDivisionDePedido = $event.target.value"
                        />
                      </div>
                      <!-- TEMPORAL PARA MOYCA -->
                      <div
                        class="container"
                      >
                        <f7-button
                          color="orange"
                          class="button-outline"
                          @click="popupDistribucionLineaPedido = true"
                        >
                          {{ $t('production.manageProductionLines.orderDetailsPopup.operations.distributeOrder') }}
                        </f7-button>
                      </div>
                    </div>
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>
              <div class="content-button padding-top padding-bottom-half">
                <f7-button
                  color="gray"
                  @click="CancelarEdicion()"
                >
                  {{ $t('common.cancel') }}
                </f7-button>
                <f7-button
                  color="orange"
                  @click="ConfirmarEdicion()"
                >
                  {{ $t('common.confirm') }}
                </f7-button>
              </div>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>

    <!-- Configuración del formulario
    <f7-popup
      class="popup-Configuracion"
      :opened="popupConfiguracionFrm"
      @popup:closed="popupConfiguracionFrm = false"
    >
      <f7-navbar
        :title="$t('common.configuration')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupConfiguracionFrm = false">
            {{ $t('common.x') }}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <div class="div-frmConfiguracion-cabeceraFormulario">
          <f7-row class="">
            <f7-col width="60">
              <span class="span-texto-gris-14-500"> Parametros de Configuración: </span>
            </f7-col>

            <PCConfiguracionComunProcesosTA
              @close="popupConfiguracionFrm=false"
            />
          </f7-row>
        </div>
      </div>
    </f7-popup>
    -->

    <!-- Popup Incidencias pedidos -->
    <f7-popup
      class="popup-incidenciasPedidosss"
      :opened="popupIncidenciasPedidos"
      @popup:closed="popupIncidenciasPedidos = false"
    >
      <f7-navbar
        :title="$t('production.manageProductionLines.incidentsPopup.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link
            class="padding-right-half"
            @click="popupIncidenciasPedidos = false"
          >
            <img
              alt="iconClose"
              src="@/static/icons/ic_close.svg"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCIncidenciasPedidosPlanificacion
        v-if="lineaSeleccionada != null"
        ref="PCIncidenciasPedidosPlanificacion"
        :production-line="lineaSeleccionada"
        :automatic-update-interval="60"
        :production-line-first="lineaSeleccionadaAlIniciarFormulario"
        @change="ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
                 popupIncidenciasPedidos = false"
        @incidence="EventIncidencePedidos"
      />
    </f7-popup>

    <!-- Popup Distribuir Lineas de pedido en otras lineas de producción -->
    <f7-popup
      v-if="pedidoSeleccionado != null"
      v-model:opened="popupDistribucionLineaPedido"
      class="popup-distribuirPlanificacion"
      @popup:closed="RestComponentDistrubuirPlanificacion"
    >
      <f7-navbar
        :title="$t('production.manageProductionLines.distributeOrderPopup.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            class="padding-right-half"
          >
            <img
              alt="iconClose"
              src="@/static/icons/ic_close.svg"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="content-popup">
        <PCDistrubuirPlanificacion
          ref="PCDistrubuirPlanificacion"
          :production-line="lineaSeleccionada"
          :sales-order-line="pedidoSeleccionado"
          @change="EventDistribuirPlanificacionCambiado"
          @cancel="popupDistribucionLineaPedido = false"
        />
      </div>
    </f7-popup>

    <f7-popup
      class="LineasPedidoVentaOrdenYParteProduccion-popup"
      :opened="popupLineasPedido"
      @popup:closed="popupLineasPedido = false; ActualizarPedidosPenditesDePlanificarYPlanificadosLinea()"
    >
      <TheNavbar
        :style="appTheme"
        :nav-title="$t('common.salesOrderLines')"
        :popup-close-btn-enable="true"
      />
      <!-- Type: 1 -> Procedimiento de WS, Type: 2 -> Procedimiento de SQL -->
      <PCLineasPedidoVentaOrdenYParteProduccion
        v-if="popupLineasPedido"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { VueDraggableNext } from 'vue-draggable-next';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import PCDistrubuirPlanificacion from '@/components/production/productionLinesManagement/PCDistrubuirPlanificacion.vue';
import PCIncidenciasPedidosPlanificacion from '@/components/production/productionLinesManagement/PCIncidenciasPedidosPlanificacion.vue';
import eventBus from '@/js/event-bus'; // Import the EventBus.
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCSupplementaryData from '@/components/common/UCSupplementaryData.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import SoporteCadena from '@/js/common/HiChainSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import TheNavbar from '@/components/TheNavbar.vue';

import { HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import ConexionTA, {
  callCambiarOrdenPedidosPlanificados,
  callEliminarPedidoPlanificadoEnPuntoPaletizado,
  callObtenerPedidosPlanificadosPuntoDePaletizado,
  callPlanificarPedidoEnPuntoPaletizado,
} from '@/js/services/traceability/APITraceability';
import { LOGO_HISPATEC } from '@/js/common/constants';
import PCMensajesInformativosPlanificacion from '@/components/production/traceability/PCMensajesInformativosPlanificacion.vue';
import PCLineasPedidoVentaOrdenYParteProduccion from '@/components/production/traceability/PCLineasPedidoVentaOrdenYParteProduccion.vue';
import PCDatosAdjuntosEntidad from '@/components/production/traceability/PCDatosAdjuntosEntidad.vue';
import { callExecuteSPERP } from '@/js/services/APIErp';
import PCDetalleLineaPedidoVenta from '@/components/production/traceability/PCDetalleLineaPedidoVenta.vue';
import PCOperacionesPersonalizadas from '@/components/production/traceability/PCOperacionesPersonalizadas.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import { sleep } from '@/js/utils/sleep';
import { useSortedProductionLines } from '@/composables/useSortedProductionLines';
import { reactive, ref, watchEffect } from 'vue';

export default {
  name: 'FrmManageProductionLines',
  components: {
    PCSideNavbar,
    VueDraggableNext,
    UCPreload,
    // PCConfiguracionComunProcesosTA,
    PCMensajesInformativosPlanificacion,
    PCDatosAdjuntosEntidad,
    PCDetalleLineaPedidoVenta,
    UCSearchEntityERP,
    UCDatePicker,
    UCSupplementaryData,
    PCIncidenciasPedidosPlanificacion,
    PCDistrubuirPlanificacion,
    PCOperacionesPersonalizadas,
    PCLineasPedidoVentaOrdenYParteProduccion,
    TheNavbar,
  },

  setup() {
    const { sortedProductionLines } = useSortedProductionLines();

    const listadoPedidosPendientes = ref(null); // Mantiene los pedidos planificados.
    const listaFiltros = ref([]);
    const filterSelected = reactive({
      date: null,
      customerName: null,
      reference: null,
    });

    watchEffect(() => {
      if (!listadoPedidosPendientes.value || listadoPedidosPendientes.value.length === 0) {
        listaFiltros.value = [];
        return;
      }

      const uniqueClientes = new Set();
      const uniqueReferences = new Set();

      const dateInit = filterSelected.date?.Init
        ? new Date(`${filterSelected.date.Init.getFullYear()}/${filterSelected.date.Init.getMonth() + 1}/${filterSelected.date.Init.getDate()}`).getTime()
        : null;
      const dateFin = filterSelected.date?.End
        ? new Date(`${filterSelected.date.End.getFullYear()}/${filterSelected.date.End.getMonth() + 1}/${filterSelected.date.End.getDate()}`).getTime()
        : null;

      listaFiltros.value = listadoPedidosPendientes.value.filter((item) => {
        // Filter by client
        const isMatchingClient = !filterSelected.customerName || item.NombreCliente === filterSelected.customerName;
        if (isMatchingClient && !uniqueClientes.has(item.NombreCliente)) {
          uniqueClientes.add(item.NombreCliente);
        } else if (!isMatchingClient) {
          return false;
        }

        // Filter by reference
        const isMatchingReference = !filterSelected.reference || item.ReferenciaPedidoVenta === filterSelected.reference;
        if (isMatchingReference && !uniqueReferences.has(item.ReferenciaPedidoVenta)) {
          uniqueReferences.add(item.ReferenciaPedidoVenta);
        } else if (!isMatchingReference) {
          return false;
        }

        // Filter by date range
        const itemDate = new Date(item.FechaSalida.toString()).getTime();
        if (dateInit !== null && itemDate < dateInit) {
          return false;
        }

        if (dateFin !== null && itemDate > dateFin) {
          return false;
        }

        return true;
      });
    });

    return {
      sortedProductionLines,
      listadoPedidosPendientes,
      listaFiltros,
      filterSelected,
    };
  },

  data() {
    return {
      lineaSeleccionada: null, // Mantiene la linea seleccionada.
      puntosDePaletizado: null, // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      puntoDePaletizadoSeleccionado: null, // Mantiene el punto de paletizado seleccionado.
      listadoPedidosPlanificados: null, // Mantiene los pedidos planificados.
      mostrarPrecargaPedidosPlanificados: false, // Controla la precarga.
      mostrarPrecargaPedidosPendientesPlanificar: false, // Controla la precarga.
      popupEdicionPedidoAbierto: false, // Controla la apertura del popup que permite dividir el pedido.
      pedidoSeleccionado: null, // Mantiene el pedido esta seleccionado para su edición.
      valorNuevaCantidadPaletParaDivisionDePedido: 0, //
      lineaSeleccionadaAlIniciarFormulario: null, // Mantiene la ultima linea seleccionada en este o otros frm para que cuando se abra el frm carge la ultima.
      pedidoSeleccionadoEstaPlanificado: false, // Cuando se selecciona el detalle de un pedido lo establece.
      contadorDeLlamadasPendientesDeRespuestaEnFrm: 0, // Controla el número de llamadas al WS que se estan realizando en el frm sin respuesta.
      // popupConfiguracionFrm: false,
      nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado: null, // Si se establece un valor, cuando se cierre el popupEdicionPedidoAbierto con la confirmación cambiara la linea pedido venta a la nueva linea de producción.
      popupIncidenciasPedidos: false, // Controla la apertura del popup.
      popupDistribucionLineaPedido: false, // Controla la apertura del popup.
      numberIncidences: null, // número de incidencias que tenemos en esa linea de pedido
      // icClose,
      datosLineasPedidoPendientesPlanificarParaPersonalizaciones: [], // Almacen los datos de las personalizaciones de las lineas de pedido pendientes de planificar
      datosLineasPedidoPlanificadasParaPersonalizaciones: [], // Almacen los datos de las personalizaciones de las lineas de pedido pendientes de planificar
      personalizacionPCTarjetaPendientePlanificacionActiva: false, // Controla si estan activas las personalizaciones en las tarjetas pendientes de p
      personalizacionPuntoPalrtizadoActiva: false, // Controla si estan activas las personalizaciones en los puntos de paletizadolanificación
      personalizacionPCTarjetaPlanificacionActiva: false, // Controla si estan activas las personalizaciones en las tarjetas planificadas
      Serfruit: {}, // Controla si el pedido está planificado en Serfruit. Si lo está, no se puede desplanificar hasta que no se desplanifique de Serfruit.
      dragOptions: { draggable: '.movible' }, // Permite que se pueda mover o no la tarjeta de pedido

      /**
       * Mantiene el timer que realiza las actualizaciones automaticas.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomatico: null,

      lineasProduccion: null,
      popupLineasPedido: null,
      LOGO_HISPATEC,
      datosComplementariosAObtener: useParamRef('DatosComplementariosAObtener'),
      permitirCrearOrdenYParteDeProduccionPorPedidoEnMovilidad: useParamRef('PermitirCrearOrdenYParteDeProduccionPorPedidoEnMovilidad'),
      logoApp: useSettingRef('App.Logo'),
      filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado: useSettingRef(
        'Trazabilidad.Alertas.FiltrarPorLineaYPuntoPaletizadoSeleccionado',
      ),
      mostrarAlertasYNotificacionesDePedidosModificados: useSettingRef(
        'Trazabilidad.Alertas.MostrarAlertasPedidosModificados',
      ),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'lineaDeProduccionSeleccionada',
      'criteriosDeBusquedaParaAlertasNotificacionDelUsuario',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    filtroCliente() {
      return Array.from(new Set(this.listaFiltros.map((item) => item.NombreCliente)))
        .map((NombreCliente) => ({ NombreCliente }));
    },

    filtroReference() {
      return Array.from(new Set(this.listaFiltros.map((item) => item.ReferenciaPedidoVenta)))
        .map((ReferenciaPedidoVenta) => ({ ReferenciaPedidoVenta }));
    },
  },

  watch: {
    contadorDeLlamadasPendientesDeRespuestaEnFrm(val) {
      if (val === 0) {
        this.ActualizarAlertasYNotificaciones(); // Cuando esta cargado todo actualizamos las alertas.
      }
    },
    listadoPedidosPendientes(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPedidosPendientesPlanificar(val); // Carga de personalizacion
      }
    },
    listadoPedidosPlanificados(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPedidosPlanificados(val); // Carga de personalizacion
      }
    },
  },
  mounted() {
    this.IncializarFrm();
  },
  created() {
    this.ActivarListener();
  },
  unmounted() {
    this.DesactivarListener();
    this.EliminarIntervaloActualizacionesAutomaticas();
  },

  methods: {
    /** ** Método IncializarFrm */
    IncializarFrm() {
      Log(this, this.IncializarFrm.name);
      // Sol.221815  - Cuando salgo para volcar y vuelvo a entrar en el paletizado, debe seguir cargada la última línea que estuvo seleccionada.
      this.lineaSeleccionadaAlIniciarFormulario = this.lineaDeProduccionSeleccionada;
      // sol.222038 - Si lineaSeleccionadaAlIniciarFormulario es null obtenemos la linea por defecto definida en el trabajador.
      this.lineaSeleccionadaAlIniciarFormulario ??= this.lineasDeProduccionDelUsuarioDefinidaEnERP;
      this.lineaSeleccionada = this.lineaSeleccionadaAlIniciarFormulario;
      this.lineasProduccion = this.sortedProductionLines;

      this.ConfigurarPersonalizacionesFrm();
    },

    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('actualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido', () => {
        this.ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('actualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido');
    },

    ConfigurarPersonalizacionesFrm() {
      Log(this, this.ConfigurarPersonalizacionesFrm.name);
      this.personalizacionPCTarjetaPendientePlanificacionActiva = SoportePersonalizacion.ExistePersonalizacion('frmGestionLineaProduccion', 'PCTarjetaPendientePlanificacion');
      this.personalizacionPCTarjetaPlanificacionActiva = SoportePersonalizacion.ExistePersonalizacion('frmGestionLineaProduccion', 'PCTarjetaPlanificacion');
      this.personalizacionPuntoPalrtizadoActiva = SoportePersonalizacion.ExistePersonalizacion('frmGestionLineaProduccion', 'PCSelectorPuntoPaletizado');
    },

    ProgramarIntervaloActualizacionesAutomaticas() {
      Log(this, this.ProgramarIntervaloActualizacionesAutomaticas.name);
      this.actualizadorAutomatico = setInterval(() => {
        this.ObtenerCantidadDePales();
      }, 60000);
    },

    EliminarIntervaloActualizacionesAutomaticas() {
      Log(this, this.EliminarIntervaloActualizacionesAutomaticas.name);
      if (this.actualizadorAutomatico) {
        clearInterval(this.actualizadorAutomatico);
      }
    },

    ObtenerCantidadDePales() {
      Log(this, this.ObtenerCantidadDePales.name);
      if (this.listadoPedidosPendientes != null) {
        this.ActualizarCantidadesPales();
      }
    },

    ComprobarAlEliminar() {
      Log(this, this.ComprobarAlEliminar.name);
      if (Object.keys(this.Serfruit).length !== 0 && !this.Serfruit.DesplanificarSerfruit) {
        HiNotification.Toast(this.$t('production.manageProductionLines.info.unplanifyToMoveToastText'));
      }
    },

    SeleccionarPedido() {
      Log(this, this.SeleccionarPedido.name);
      this.popupLineasPedido = true;
    },

    ActualizarCantidadPalesPlanificadosYPendientesPlanificacion(listaActualizada) {
      Log(this, this.ActualizarCantidadPalesPlanificadosYPendientesPlanificacion.name);

      listaActualizada.forEach((pedido) => {
        const {
          Id,
          CantidadPalet,
          CantidadPalesTotalesDeLaLineaPedido,
        } = pedido;

        const pendientesEncontrado = this.listaFiltros.find((filtro) => filtro.ParteProduccionPrevistoSalida.Id === Id);
        const planificadoEncontrado = this.listadoPedidosPlanificados.find((filtro) => filtro.ParteProduccionPrevistoSalida.Id === Id);

        if (pendientesEncontrado) {
          pendientesEncontrado.CantidadPalet = CantidadPalet;
          pendientesEncontrado.CantidadPalesTotalesDeLaLineaPedido = CantidadPalesTotalesDeLaLineaPedido;
        }
        if (planificadoEncontrado) {
          planificadoEncontrado.CantidadPalet = CantidadPalet;
          planificadoEncontrado.CantidadPalesTotalesDeLaLineaPedido = CantidadPalesTotalesDeLaLineaPedido;
        }
      });
    },

    ChangedDateQuery(newValue) {
      Log(this, this.ChangedDateQuery.name);

      this.filterSelected.date = newValue;
      if (!this.filterSelected.date) {
        this.$refs.UCClientComponent.Clear();
      }
    },

    EventClientSelected(val) {
      Log(this, this.EventClientSelected.name);

      this.filterSelected.customerName = val?.NombreCliente;
      if (!val) {
        this.$refs.UCreferenciasComponent.Clear();
      }
    },

    EventReferenceSelected(val) {
      Log(this, this.EventReferenceSelected.name);
      this.filterSelected.reference = val?.ReferenciaPedidoVenta;
    },

    EventFamilySelected(val) {
      Log(this, this.EventFamilySelected.name);
      this.filterSelected.family = val;
    },

    EventIncidencePedidos(val) {
      Log(this, this.EventIncidencePedidos.name);
      this.numberIncidences = val;
    },

    EventInicializarFiltros() {
      Log(this, this.EventInicializarFiltros.name);
      this.$refs.UCClientComponent.Clear();
      this.$refs.UCreferenciasComponent.Clear();
      this.$refs.UCDatePicker.clear();
    },

    async EventDistribuirPlanificacionCambiado() {
      Log(this, this.EventDistribuirPlanificacionCambiado.name);
      this.popupDistribucionLineaPedido = false;
      await sleep(500);
      this.popupEdicionPedidoAbierto = false;
      this.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
    },

    LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);

      if (lineaSeleccionada != null) {
        this.lineaDeProduccionSeleccionada = lineaSeleccionada;
      }

      this.lineaSeleccionada = lineaSeleccionada;
      this.EventInicializarFiltros();

      if (lineaSeleccionada == null) {
        this.puntosDePaletizado = null;
        this.listadoPedidosPlanificados = [];
        this.listadoPedidosPendientes = [];
        return;
      }

      if (this.lineaSeleccionada.DispositivoBaseDatos !== null) {
        const puntosPaletizado = [];

        if (this.lineaSeleccionada.PuntosDePaletizado != null) {
          this.lineaSeleccionada.PuntosDePaletizado.forEach((p) => {
            if (p.UsoEnIntegracion) {
              puntosPaletizado.push(p);
            }
          });

          this.lineaSeleccionada.PuntosDePaletizado = puntosPaletizado;
        }
      }

      this.ObtenerPedidosPendientesPlanificacion();
      this.listadoPedidosPendientes = [];
      this.puntosDePaletizado = this.lineaSeleccionada.PuntosDePaletizado;
      // Por defecto se selecciona el primer punto de paletizado.
      if (this.puntosDePaletizado.length > 0) {
        this.PuntoDePaletizadoSeleccionado(this.puntosDePaletizado[0]);
      } else {
        this.puntoDePaletizadoSeleccionado = null;
        this.PuntoDePaletizadoSeleccionado(null);
        HiNotification.Toast(this.$t('production.manageProductionLines.info.noPalletizingPointsToastText'));
        this.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
      }
    },

    PuntoDePaletizadoSeleccionado(puntoSeleccionado) {
      Log(this, this.PuntoDePaletizadoSeleccionado.name);
      if (puntoSeleccionado == null) {
        this.puntoDePaletizadoSeleccionado = null;
        this.listadoPedidosPlanificados = null;
        return;
      }

      if (puntoSeleccionado === this.puntoDePaletizadoSeleccionado) {
        return;
      }
      this.puntoDePaletizadoSeleccionado = puntoSeleccionado;
      this.listadoPedidosPlanificados = null;
      this.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
    },

    CambioRealizadoEnListadoPedidosPendientesDePlanificar(evt) {
      Log(this, this.CambioRealizadoEnListadoPedidosPendientesDePlanificar.name);

      if (this.listadoPedidosPlanificados == null) {
        HiNotification.Toast(this.$t('production.manageProductionLines.info.palletizingPointBeforePlanToastText'));
        this.listadoPedidosPendientes.push(evt.removed.element);
      }
      if (evt.removed) {
        this.listadoPedidosPendientes = this.listadoPedidosPendientes.filter((item) => item !== evt.removed.element);
      }
      Log(this, this.CambioRealizadoEnListadoPedidosPendientesDePlanificar.name, evt);
    },

    CambioRealizadoEnListadoPedidosPlanificados(evt) {
      Log(this, this.CambioRealizadoEnListadoPedidosPlanificados.name);
      // Pedido Cambiado de orden
      if (Object.hasOwn(evt, 'moved')) {
        this.GuardarOrdenPedidosActuales();
        return;
      }
      // Nuevo pedido planificado
      if (Object.hasOwn(evt, 'added')) {
        this.NuevoPedidoPlanificadoEnPuntoDePaletizado(evt.added.element);
        return;
      }
      // Eliminado Pedido planificado
      if (Object.hasOwn(evt, 'removed')) {
        const removedElement = evt.removed.element;

        const indexInListaFiltros = evt.removed.newIndex;
        this.listadoPedidosPendientes.splice(indexInListaFiltros, 0, removedElement);

        this.EliminadoPedidoPlanificadoEnPuntoPaletizado(removedElement);
      }
    },

    NuevoPedidoPlanificadoEnPuntoDePaletizado(objPedido) {
    // debugger;
      Log(this, this.NuevoPedidoPlanificadoEnPuntoDePaletizado.name);
      const self = this;
      if (this.puntoDePaletizadoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.manageProductionLines.info.needPalletizingPointOnNewOrderToastText'));
        this.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
        return;
      }
      // Si el pedido es un pedido dividio comprobamos si existen ya palés de este mismo pedido ya que se unificaran
      let actualizarAlFinalizar = false;
      if (objPedido.Dividido !== undefined && objPedido.Dividido === true) {
        actualizarAlFinalizar = true;
      }
      this.PlanificarPedidoEnPuntoPaletizado({
        salesOrderLineId: objPedido.IdLineaPedidoVenta,
        palletizingPointId: this.puntoDePaletizadoSeleccionado.Id,
        productionLineId: this.lineaSeleccionada.Id,
        quantity: objPedido.CantidadPalet,
        productionOrderId: objPedido.OrdenProduccion.Id,
        plannedProductionOutputPartId: objPedido.ParteProduccionPrevistoSalida.Id,
      })
        .then((IdPartesProduccionPrevistoSalidaPuntoPaletizado) => {
          if (objPedido.CantidadPalet > 0) {
            HiNotification.Toast(this.$t('production.manageProductionLines.info.orderPlannedToastText'));
          } else {
            HiNotification.Toast(this.$t('production.manageProductionLines.info.palletsUnplannedToastText', {
              quantity: objPedido.CantidadPalet,
            }));
            self.listadoPedidosPlanificados = [];
            self.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
            return;
          }
          // Actualizamos el IdPartesProduccionPrevistoSalidaPuntoPaletizado
          self.listadoPedidosPlanificados.find(
            (p) => p.IdPartesProduccionPrevistoSalidaPuntoPaletizado === 0
              && p.IdLineaPedidoVenta === objPedido.IdLineaPedidoVenta,
          ).IdPartesProduccionPrevistoSalidaPuntoPaletizado = IdPartesProduccionPrevistoSalidaPuntoPaletizado;
          self.GuardarOrdenPedidosActuales(false);
          if (actualizarAlFinalizar) {
            self.listadoPedidosPlanificados = [];
            self.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
            self.ObtenerPedidosPendientesPlanificacion();
          }
        })
        .catch((error) => {
          HiNotification.Toast(error);
          self.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
          self.ObtenerPedidosPendientesPlanificacion();
        });
    },

    EliminadoPedidoPlanificadoEnPuntoPaletizado(objPedido) {
      Log(this, this.EliminadoPedidoPlanificadoEnPuntoPaletizado.name);
      const self = this;
      this.EliminarPedidoPlanificadoEnPuntoPaletizado(
        objPedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado,
        this.puntoDePaletizadoSeleccionado.Id,
        objPedido.IdLineaPedidoVenta,
      )
        .then(() => {
          HiNotification.Toast(this.$t('production.manageProductionLines.info.orderUnplannedToastText'));
          // Eliminamos el IdPartesProduccionPrevistoSalidaPuntoPaletizado del pedido desplanificado
          self.listadoPedidosPendientes.find(
            (p) => p.IdPartesProduccionPrevistoSalidaPuntoPaletizado
              === objPedido.IdPartesProduccionPrevistoSalidaPuntoPaletizado
              && p.IdLineaPedidoVenta === objPedido.IdLineaPedidoVenta,
          ).IdPartesProduccionPrevistoSalidaPuntoPaletizado = 0;
          // self.GuardarOrdenPedidosActuales()
        })
        .catch((error) => {
          if (error.Codigo === 214) {
            HiNotification.Toast(this.$t('production.manageProductionLines.unplanValidation.needFinishToastText'));
          } else if (error.Mensaje !== '') {
            HiNotification.Toast(error.Mensaje);
          } else {
            HiNotification.Toast(this.$t('production.manageProductionLines.unplanValidation.errorToastText'));
          }
          self.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
          self.ObtenerPedidosPendientesPlanificacion();
        });
    },

    ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga() {
      Log(this, this.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga.name);
      const self = this;
      self.mostrarPrecargaPedidosPlanificados = true;
      self.listadoPedidosPlanificados = [];

      if (this.puntosDePaletizado.length === 0) {
        self.mostrarPrecargaPedidosPlanificados = false;
        return;
      }
      this.ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado()
        .then((result) => {
          if (result.Valor) {
            self.mostrarPrecargaPedidosPlanificados = false;
            self.listadoPedidosPlanificados = JSON.parse(result.Mensaje);
          } else {
            // HiNotification.Toast(result.Mensaje);
            self.mostrarPrecargaPedidosPlanificados = false;
            self.listadoPedidosPlanificados = [];
          }
        })
        .catch((error) => {
          self.mostrarPrecargaPedidosPlanificados = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga.name, error);
        });
    },

    /**
     * @param {object} options
     * @param {boolean} [options.resetFilters] - Whether to reset the filters or not.
     * @return {void}
     */
    ActualizarPedidosPenditesDePlanificarYPlanificadosLinea({
      resetFilters = false,
    } = {}) {
      Log(this, this.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea.name);
      this.popupIncidenciasPedidos = false;
      this.ActualizarPedidosPendientesDePlanificar();
      this.ObtenerPedidosPlanificadosPuntoPaletizadoConPreloaderDeCarga();
      this.$refs.PCIncidenciasPedidosPlanificacion.UpdateMainData();

      if (resetFilters) {
        this.EventInicializarFiltros();
      }
    },

    ActualizarPedidosPendientesDePlanificar() {
      Log(this, this.ActualizarPedidosPendientesDePlanificar.name);
      this.listadoPedidosPendientes = [];
      this.ObtenerPedidosPendientesPlanificacion();
    },

    AbrirFormularioEdicionDePedidoNoPlanificado(objPedido) {
      Log(this, this.AbrirFormularioEdicionDePedidoNoPlanificado.name);
      this.pedidoSeleccionadoEstaPlanificado = false;
      this.pedidoSeleccionado = objPedido;
      this.valorNuevaCantidadPaletParaDivisionDePedido = this.pedidoSeleccionado.CantidadPalet; // Establecemos al maximo.
      this.popupEdicionPedidoAbierto = true;
    },

    AbrirFormularioEdicionDePedidoPlanificado(objPedido) {
      Log(this, this.AbrirFormularioEdicionDePedidoPlanificado.name);
      this.pedidoSeleccionadoEstaPlanificado = true;
      this.pedidoSeleccionado = objPedido;
      this.popupEdicionPedidoAbierto = true;
    },

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.pedidoSeleccionado = null;
      this.valorNuevaCantidadPaletParaDivisionDePedido = 0;
      this.popupEdicionPedidoAbierto = false;
      this.nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado = null;
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);
      // Comprobamos si se ha realizado alguna Operación en el frm
      this.popupEdicionPedidoAbierto = false;
      // * - Dividir el pedido.
      if (this.pedidoSeleccionado.CantidadPalet !== this.valorNuevaCantidadPaletParaDivisionDePedido) {
        this.DividirLineaPedidoVentaConNuevaCantidad();
        return;
      }

      // * - Cambiar linea producción del Pedido.
      if (this.nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado != null) {
        this.AsignarLineaPedidoVentaSeleccionadoEnOtraLineaProduccion();
      }
    },

    AsignarLineaPedidoVentaSeleccionadoEnOtraLineaProduccion() {
      Log(this, this.AsignarLineaPedidoVentaSeleccionadoEnOtraLineaProduccion.name);

      const self = this;
      const preloaderText = this.$t('production.manageProductionLines.assignSalesOrderLine.preloaderText', {
        code: this.nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado.Codigo,
      });

      PreloaderGH(
        true,
        false,
        preloaderText,
      );
      this.Conexion_AsignarPalesDeLineaPedidoEnOtraLineaDeProduccion(
        this.pedidoSeleccionado.ParteProduccion.Id,
        this.pedidoSeleccionado.ParteProduccionPrevistoSalida.Id,
        this.pedidoSeleccionado.CantidadPalet,
        this.nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado.Id,
      )
        .then((result) => {
          if (result.Valor) {
            PreloaderGH(false);
            HiNotification.Toast(this.$t('production.manageProductionLines.assignSalesOrderLine.successToastText'));
            self.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
          } else {
            PreloaderGH(false);
            HiNotification.Toast(result.Mensaje);
          }
        })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Alert(`${this.$t('common.checkYourConnection')} ${error}`, this.$t('common.error'));
          LogError(this, this.AsignarLineaPedidoVentaSeleccionadoEnOtraLineaProduccion.name, error);
        });
    },

    DividirLineaPedidoVentaConNuevaCantidad() {
      Log(this, this.DividirLineaPedidoVentaConNuevaCantidad.name);
      const tempDivisionDePedido = { ...this.pedidoSeleccionado }; //  Clonamos
      tempDivisionDePedido.CantidadPalet = this.valorNuevaCantidadPaletParaDivisionDePedido;
      tempDivisionDePedido.Dividido = true; // Asignamos la propiedad Dividido true para conocer que es un pedido dividido en presentación.
      // El pedido original lo dejamos con la cantidad restada
      this.pedidoSeleccionado.CantidadPalet -= this.valorNuevaCantidadPaletParaDivisionDePedido;
      this.pedidoSeleccionado.Dividido = true; // Asignamos la propiedad Dividido true para conocer que es un pedido dividido en presentación.
      // Insetamos el nuevo pedido despues del dividido.
      const tempIndex = this.listadoPedidosPendientes.findIndex(
        (p) => p.IdPartesProduccionPrevistoSalidaPuntoPaletizado
          === this.pedidoSeleccionado.IdPartesProduccionPrevistoSalidaPuntoPaletizado
          && p.IdLineaPedidoVenta === this.pedidoSeleccionado.IdLineaPedidoVenta,
      );
      this.listadoPedidosPendientes.splice(tempIndex + 1, 0, tempDivisionDePedido);
    },

    FormatearCadena(cadena, longitudMaxima) {
      if (cadena == null) {
        return '';
      }
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },

    ActualizarAlertasYNotificaciones() {
      Log(this, this.ActualizarAlertasYNotificaciones.name);
      this.FiltraNotificacionesDePedidosVisualizados();
      eventBus.emit('PCVisorDeAlertasYNotificaciones_actualizarNumeroAlertas'); // Actualizamos el númerode las alertas.
    },

    /** Si en la configuracion esta establecido que se filtren las notificaciones unicamnete mostrara las de los pedidos de la linea y PP actual */
    FiltraNotificacionesDePedidosVisualizados() {
      Log(this, this.FiltraNotificacionesDePedidosVisualizados.name);
      let arrayTexto = [];
      // Consultamos si mostrar todas las alertas o solo las de pedidos visualizados.
      if (!this.filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado) {
        if (this.mostrarAlertasYNotificacionesDePedidosModificados) {
          // Filtamos las alertas de pedidos modificados (se añaden o quitan palés)
          const cadenaFiltro = 'pedido de venta ';
          arrayTexto.push(cadenaFiltro);
        }
        // Mostramos solo las alertas de pedidos visualizados.
      } else if (this.listadoPedidosPlanificados != null && this.listadoPedidosPlanificados !== undefined) {
        if (this.mostrarAlertasYNotificacionesDePedidosModificados) {
          // Filtamos las alertas de pedidos modificados (se añaden o quitan palés)
          this.listadoPedidosPlanificados.forEach((pedidoPlanificado) => {
            let cadenaFiltro = 'pedido de venta ';
            cadenaFiltro = cadenaFiltro.concat(
              SoporteCadena.EliminarEspaciosEnBlancoContenidosEnUnaCadena(pedidoPlanificado.Pedido),
            );
            arrayTexto.push(cadenaFiltro);
          });
          this.listadoPedidosPendientes.forEach((pedidoPlanificado) => {
            let cadenaFiltro = 'pedido de venta ';
            cadenaFiltro = cadenaFiltro.concat(
              SoporteCadena.EliminarEspaciosEnBlancoContenidosEnUnaCadena(pedidoPlanificado.Pedido),
            );
            arrayTexto.push(cadenaFiltro);
          });
        }
      }

      // Procesamos todos los filtros de las alertas con el formato necesario
      const tempFiltrosAletasFormato = [];
      arrayTexto = Array.from(new Set(arrayTexto)); // Quitamos los duplicados
      arrayTexto.forEach((textoAlerta) => {
        tempFiltrosAletasFormato.push({
          TipoAlertaOrigenBusqueda: 'ControlProduccion',
          TextoBusqueda: textoAlerta,
          FechaInicioBusqueda: '2022-11-15T09:41:52.330Z',
          FechaFinBusqueda: '2022-11-18T12:41:52.330Z',
        });
      });
      this.criteriosDeBusquedaParaAlertasNotificacionDelUsuario = tempFiltrosAletasFormato;
    },

    EventLineaDeProduccionSelected(obj) {
      Log(this, this.EventLineaDeProduccionSelected.name);
      this.establecerLineaProduccionSeleccionadaPorDefecto(obj);
    },

    /*
    ObtenerTotalEnvasesDisponiblesPlanificarSegunNumeroPales(lineaPedido) {

      /*
      if (lineaPedido != null && lineaPedido.CantidadPalet != null && lineaPedido.CantidadPalet !== undefined && lineaPedido.CantidadEnvasesPorPalet != null && lineaPedido.CantidadEnvasesPorPalet !== undefined) {
        return lineaPedido.CantidadPalet * lineaPedido.CantidadEnvasesPorPalet;
      }

      return 0;

     return lineaPedido.CantidadEnvasesPorPalet * lineaPedido.CantidadPalet;
    },
    */

    /* Sol.230274  (Palés reservados con posterioridad a la planificación) */
    ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido() {
      Log(this, this.ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido.name);
      const self = this;
      PreloaderGH(true, false, this.$t('common.updatingQuantities'));
      this.Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta(
        this.puntoDePaletizadoSeleccionado.Id,
        this.pedidoSeleccionado.IdLineaPedidoVenta,
        this.pedidoSeleccionado.IdPartesProduccionPrevistoSalidaPuntoPaletizado,
        this.pedidoSeleccionado.OrdenProduccion.Id,
      )
        .then((result) => {
          if (result.Valor) {
            PreloaderGH(false);
            self.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
            HiNotification.Toast(result.Mensaje);
            self.popupEdicionPedidoAbierto = false;
          } else {
            PreloaderGH(false);
            HiNotification.Toast(result.Mensaje);
            self.popupEdicionPedidoAbierto = false;
          }
        })
        .catch((error) => {
          PreloaderGH(false);
          // self.mostrarPrecargaPedidosPlanificados = false;
          HiNotification.Alert(`${this.$t('common.checkYourConnection')} ${error}`, this.$t('common.error'));
          LogError(this, this.ActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido.name, error);
        });
    },

    EnviarLineaPedidoOtraLineaDeProduccion(nuevaLineaProduccionCambio) {
      Log(this, this.EnviarLineaPedidoOtraLineaDeProduccion.name);
      if (nuevaLineaProduccionCambio != null && nuevaLineaProduccionCambio.Id === this.LineaProduccionSeleccionada.Id) {
        return;
      }
      this.nuevaLineaProduccionParaAsignarPedidoVentaSeleccionado = nuevaLineaProduccionCambio;
      // NOTA: El proceso se hace una vez que el usuario confirma.
    },
    RestComponentDistrubuirPlanificacion() {
      Log(this, this.RestComponentDistrubuirPlanificacion.name);
      this.$refs.PCDistrubuirPlanificacion.ResetComponent();
    },

    async ObtenerPersonalizacionesPedidosPendientesPlanificar(lstPentPlanificaciones) {
      Log(this, this.ObtenerPersonalizacionesPedidosPendientesPlanificar.name);
      if (!this.personalizacionPCTarjetaPendientePlanificacionActiva) {
        return;
      } // Comprurba si esta activa.
      this.datosLineasPedidoPendientesPlanificarParaPersonalizaciones = [];
      const entidades = [];
      const arrayLstPenPlanificaciones = lstPentPlanificaciones.map((i) => [i.ParteProduccionPrevistoSalida.Id, i]);

      const mapPenPlanificaciones = new Map(arrayLstPenPlanificaciones);

      const lstPenPlanificacionesUnicos = [...mapPenPlanificaciones.values()];

      lstPenPlanificacionesUnicos.forEach((e) => {
        entidades.push({ Id: e.ParteProduccionPrevistoSalida.Id });
      });

      this.datosLineasPedidoPendientesPlanificarParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmGestionLineaProduccion', 'PCTarjetaPendientePlanificacion');
    },

    async ObtenerPersonalizacionesPedidosPlanificados(lstPlanificaciones) {
      Log(this, this.ObtenerPersonalizacionesPedidosPlanificados.name);
      if (!this.personalizacionPCTarjetaPlanificacionActiva) {
        return;
      } // Comprueba si esta activa.
      this.datosLineasPedidoPlanificadasParaPersonalizaciones = [];
      const entidades = [];
      const arrayLstPlanificaciones = lstPlanificaciones.map((i) => [i.IdPartesProduccionPrevistoSalidaPuntoPaletizado, i]);

      const mapPlanificaciones = new Map(arrayLstPlanificaciones);

      const lstPlanificacionesUnicos = [...mapPlanificaciones.values()];

      lstPlanificacionesUnicos.forEach((e) => {
        entidades.push({ Id: e.IdPartesProduccionPrevistoSalidaPuntoPaletizado });
      });
      this.datosLineasPedidoPlanificadasParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmGestionLineaProduccion', 'PCTarjetaPlanificacion');

      const esSerfruit = this.lineaSeleccionada.DispositivoBaseDatos;
      if (esSerfruit) {
        this.Serfruit.EsSerfruit = true;
      }

      // Particularización solo para Integraciones con Serfruit.
      if (this.puntoDePaletizadoSeleccionado.UsoEnIntegracion) {
        this.Serfruit = { EsSerfruit: false, EsPlanificada: false, IdEntidad: 0 };
        const esPlanificada = this.datosLineasPedidoPlanificadasParaPersonalizaciones.find((d) => d.OperacionesPersonalizadas.some((o) => o.Nombre === 'Desplanificar Serfuit' && o.Orden === 3));

        if (esPlanificada) {
          this.Serfruit.EsPlanificada = true;
          this.Serfruit.IdEntidad = esPlanificada.Entidad.Id;
        }

        if (this.Serfruit.EsSerfruit) {
          this.EliminarIntervaloActualizacionesAutomaticas();
          this.ProgramarIntervaloActualizacionesAutomaticas();
        }
      }
    },

    GuardarOrdenPedidosActuales(mostrarNotificacion) {
      Log(this, this.GuardarOrdenPedidosActuales.name);
      // Obtenemos los identificadores de pedido en el orden actual.
      let tempCadenaIds = '';
      for (let i = 0; i < this.listadoPedidosPlanificados.length; i += 1) {
        tempCadenaIds = `${tempCadenaIds},${this.listadoPedidosPlanificados[i].IdPartesProduccionPrevistoSalidaPuntoPaletizado}`;
      }
      tempCadenaIds = tempCadenaIds.substring(1, tempCadenaIds.length);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      callCambiarOrdenPedidosPlanificados(tempCadenaIds)
        .then((result) => {
          if (result.Valor) {
            this.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
            if (mostrarNotificacion === undefined || mostrarNotificacion === true) {
              HiNotification.Toast(this.$t('production.manageProductionLines.changeOrder.successToastText'));
            }
          } else {
            HiNotification.Alert(result.Mensaje, this.$t('common.error'));
          }
        })
        .catch((error) => {
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.GuardarOrdenPedidosActuales.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },

    /**
     * Planifica un pedido en un punto de paletizado.
     * @param {Parameters<typeof callPlanificarPedidoEnPuntoPaletizado>[0]} data
     */
    PlanificarPedidoEnPuntoPaletizado(data) {
      Log(this, this.PlanificarPedidoEnPuntoPaletizado.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        callPlanificarPedidoEnPuntoPaletizado(data)
          .then((result) => {
            if (result.Valor) {
              resolve(Number.parseInt(result.Mensaje, 10));
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            reject();
            LogError(this, this.PlanificarPedidoEnPuntoPaletizado.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    EliminarPedidoPlanificadoEnPuntoPaletizado(idParteProduccionPrevSalidaPPal, idPuntoPaletizado, idLineaPedidoVenta) {
      Log(this, this.EliminarPedidoPlanificadoEnPuntoPaletizado.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        callEliminarPedidoPlanificadoEnPuntoPaletizado(
          idParteProduccionPrevSalidaPPal,
          idPuntoPaletizado,
          idLineaPedidoVenta,
        )
          .then((result) => {
            if (result.Valor) {
              resolve();
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            reject();
            LogError(this, this.EliminarPedidoPlanificadoEnPuntoPaletizado.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado() {
      Log(this, this.ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        callObtenerPedidosPlanificadosPuntoDePaletizado(this.puntoDePaletizadoSeleccionado.Id)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject();
            LogError(this, this.ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    ObtenerPedidosPendientesPlanificacion() {
      Log(this, this.ObtenerPedidosPendientesPlanificacion.name);
      const self = this;
      this.mostrarPrecargaPedidosPendientesPlanificar = true;
      this.listadoPedidosPendientes = [];
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      ConexionTA.callObtenerPedidosPendientesPlanificacionXLineaProduccion(this.lineaSeleccionada.Id)
        .then((result) => {
          if (result.Valor) {
            self.listadoPedidosPendientes = JSON.parse(result.Mensaje);
          }
          self.mostrarPrecargaPedidosPendientesPlanificar = false;
        })
        .catch((error) => {
          self.mostrarPrecargaPedidosPendientesPlanificar = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.ObtenerPedidosPendientesPlanificacion.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },

    Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta(
      idPuntoPaletizado,
      idLineaPedidoVenta,
      idParteProduccionPrevistoSalidaPuntoPaletizado,
      idOrdenProduccion,
    ) {
      Log(this, this.Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callActualizarCantidadDePalesPlanificadosConLaCantidadActualPendienteDelPedido(
          idPuntoPaletizado,
          idLineaPedidoVenta,
          idParteProduccionPrevistoSalidaPuntoPaletizado,
          idOrdenProduccion,
        )
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject();
            LogError(this, this.Conexion_ActualizarCantidadDePalesPlanificadosDeUnaLineaPedidoVenta.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },

    Conexion_AsignarPalesDeLineaPedidoEnOtraLineaDeProduccion(
      idParteProduccion,
      idParteProduccionPrevistoSalida,
      cantidadPalesCambiar,
      idNuevaLineaProduccion,
    ) {
      Log(this, this.Conexion_AsignarPalesDeLineaPedidoEnOtraLineaDeProduccion.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callAsignarPalesDeLineaPedidoEnOtraLineaDeProduccion(
          idParteProduccion,
          idParteProduccionPrevistoSalida,
          cantidadPalesCambiar,
          idNuevaLineaProduccion,
        )
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            reject();
            LogError(this, this.Conexion_AsignarPalesDeLineaPedidoEnOtraLineaDeProduccion.name, error);
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },
    /*
    // Esto dejo de utilizarse por los problemas que ocasiona una desplanificación automatica desde la tablet.
    DesplanificacionAutomaticaDePedidosConReservaOModificacionDePedido(idLineaDeProduccion) {
      Log(this, this.DesplanificacionAutomaticaDePedidosConReservaOModificacionDePedido.name);
      const self = this;
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      ConexionTA.callDesplanificacionAutomaticaDePedidosConReservaOModificacionDePedido(idLineaDeProduccion)
        .then((result) => {
          if (result.Valor) {
            self.ActualizarPedidosPenditesDePlanificarYPlanificadosLinea();
            HiNotification.Toast(result.Mensaje);
          }
        })
        .catch((error) => {
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.DesplanificacionAutomaticaDePedidosConReservaOModificacionDePedido.name, error);
        })
        .finally(() => {
          self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
        });
    },
    */

    async ActualizarCantidadesPales() {
      Log(this, this.ActualizarCantidadesPales.name);
      let resultado = [];
      await callExecuteSPERP(
        'APPTRAZABILIDAD_PalesTotalesYFabricadosPedidosPlanificadosYPendientes',
        [
          { NombreParametro: 'idLineaProduccion', Valor: this.lineaSeleccionadaAlIniciarFormulario.Id },
          { NombreParametro: 'idPuntoPaletizado', Valor: this.puntoDePaletizadoSeleccionado.Id },
        ],
        'Trazabilidad.PedidoPlanificadoParaPaletizadoJSON',
      ).then((result) => {
        resultado = result.data;
        this.ActualizarCantidadPalesPlanificadosYPendientesPlanificacion(resultado);
      });
      return resultado;
    },
  },
};
</script>

<style lang="scss">
.main-gestionlineaproduccion {
  // TODO: Remove when migrated to new styles
  --f7-badge-bg-color: #616d82;
  --f7-badge-size: 25px;
  --f7-badge-font-size: 14px;
  --f7-badge-font-weight: 700;
  --f7-badge-padding: 0 4px;
  //

  --available-viewport-height: calc(100vh - var(--information-bar-height));
  --information-bar-padding-bottom: 0;

  .page-content {
    display: flex;

    .content-menu {
      background-color: #ebecf0;
      box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
      width: 80px;
    }

    .content-data {
      width: 100%;
      box-sizing: border-box;
    }

    .content-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &__actions {
        display: flex;
        align-items: center;
        flex: 80;
        justify-content: flex-end;

        &--button {
          border: 1px solid #dbe6f1;
          background-color: var(--his-disabled);
          color: var(--his-plum-shadow);
          font-size: 14px;
          font-weight: 500;
          height: 41px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          margin-right: 16px;
          border-radius: 3px;

          img {
            margin-right: 10px;
            height: 16px;
            width: 16px;
          }

          .badge-indicadorActualizacionAPP {
            left: 12px;
            background: var(--his-tomate);
          }
        }
      }

      &__logo {
        img {
          object-fit: contain;
          width: auto;
          height: 44px;
          border-radius: 6px;
          box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
        }
      }
    }

    .content-planned,
    .content-pending {
      overflow-y: hidden;
      border-radius: 6px;
      height: calc(var(--available-viewport-height) - 90px);
      background-color: #ebecf0;

      &__title {
        background-color: var(--his-plum-shadow);
        font-weight: 400;
        color: #ebecf0;
        font-size: 12px;
        padding: 6px 16px;
        border-radius: 6px 6px 0 0;
        display: flex;
        justify-content: space-between;

        &--button {
          --f7-button-font-size: 10px;
          --f7-button-min-width: 6px;
          --f7-button-bg-color: var(--his-slate-blue);
          --f7-button-border-width: 1px;
          --f7-button-height: 18px;

          color: #fff;
        }
      }

      &__results {
        background-color: #ebecf0;
        height: calc(100% - 60px);
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }

    .paletizado-points {
      border-radius: 6px;
      height: calc(var(--available-viewport-height) - 85px);
      background-color: #ebecf0;

      &__results {
        background-color: #ebecf0;
        height: calc(100% - 20px);
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }

    .content-planned {
      &__results {
        > div {
          height: calc(100% - 60px);
        }

        .no-movible {
          cursor: not-allowed;
        }
      }
    }

    .content-pending {
      &__results {
        background-color: #ebecf0;
        height: calc(100% - 92px);
        overflow-y: scroll;
      }

      .content-filters {
        display: grid;
        grid-template-columns: minmax(225px, 1fr) 1fr 1fr;
        grid-column-gap: 8px;
      }

      &__results > div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 8px;
      }
    }
  }

  .line-production {
    width: 35vw;
  }

  .page {
    background-color: #f7f7f7;
  }

  .div-contenido {
    margin-left: 100px;
    margin-right: 10px;
  }

  .titulo-almacen {
    color: var(--his-steel-blue);
    font-size: 24px;
    font-weight: 500;
    line-height: 29px;
    text-align: left;
  }

  .titulo-almacen-centro {
    color: var(--his-plum-shadow);
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.17px;
    line-height: 14px;
    text-align: left;
  }

  .selector-lineaproduccion {
    background-color: rgb(9 30 66 / 4%);
    border: 1px solid rgb(9 30 66 / 25%);
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgb(9 30 66 / 4%);
    height: 58px;
  }

  .selector-lineaproduccion-textolinea {
    color: var(--his-steel-blue);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    vertical-align: middle;
    padding-top: 15px;
    padding-left: 16px;
  }

  .selector-lineaproduccion-navegacion {
    background-color: var(--his-steel-blue);
    border-radius: 8px;
    width: 58px;
    height: 58px;
    max-width: 58px;
    max-height: 58px;
  }

  .lineas-disponibles {
    color: var(--his-plum-shadow);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.17px;
    line-height: 14px;
    text-align: left;
  }

  div.lineas-disponibles {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);

    /* height: 48px; */
    color: var(--his-steel-blue);
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    margin-top: 15px;
    vertical-align: middle;
    padding-top: 15px;
    padding-left: 16px;
    padding-bottom: 15px;
  }

  .div-elementoTarjeta .variedad {
    color: #172b4d;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    text-align: left;
  }

  .div-elementoTarjeta .row {
    padding-left: 5px;
  }

  .div-elementoTarjeta .envase {
    color: var(--his-kiwi-pulp);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
  }

  .CantidadPaletEnvase {
    color: var(--his-steel-blue);
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
  }

  .CantidadPaletEnvaseNegativa {
    color: #f44336;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
  }

  .palet {
    color: #909aab;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-align: left;
  }

  .div-elementoTarjeta {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
    margin-right: 15px;
    margin-top: 15px;
    max-height: 130px;
  }

  .div-elementoTarjetaPendienteDePlanificar {
    width: 44%;
  }

  .div-puntosPaletizadoDisponibles {
    max-height: 100%;
    height: 78vh;
    overflow-y: auto;
  }

  .div-elementoTarjetaLinea {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
    color: var(--his-steel-blue);
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    margin-bottom: 15px;
    vertical-align: middle;
    padding: 15px;
    margin-top: 0;
  }

  .div-elementoTarjetaLineaSeleccionada {
    background-color: var(--his-steel-blue);
    color: #fff;
  }

  .draggable-pedidosPlanificados {
    min-height: 70vh;
    min-width: 20vw;
  }

  .draggable-pedidosPendientesPlanificado {
    min-height: 35vh;
    min-width: 45vw;
    display: flex;
    flex-wrap: wrap;
  }

  .div-pedidosPlanificados {
    max-height: 100%;
    height: 78vh;
    width: 19vw;
    overflow-y: auto;
    background-color: #ebecf0;
    border-radius: 4px 4px 10px 10px;
    padding-left: 14px;
    padding-right: 14px;
    overflow-x: hidden;
    margin-top: 15px;
  }

  .div-pedidosPendientesDePlanificar {
    max-height: 100%;
    height: 78vh;
    width: 42vw;
    overflow-y: auto;
    background-color: #ebecf0;
    border-radius: 4px 4px 10px 10px;
    padding-left: 14px;
    padding-right: 14px;
    overflow-x: hidden;
  }

  .span-tituloColumnas {
    color: var(--his-plum-shadow);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.17px;
    line-height: 14px;
    text-align: left;
  }

  /*  Estilos de las listas Dragg */
  .sortable-ghost {
    max-height: 34px;
    background: #fff;
    overflow: hidden;
    display: block;
  }

  .sortable-fallback {
    background: #fff;
    border: 2px solid yellow;
    opacity: 1 !important;
    overflow: hidden;
    max-height: 50px;
  }

  .btn-actualizarPedidosPendientesDePlanificar {
    float: right;
    margin-right: 16px;
  }

  .btn-actualizarPedidosPendientesDePlanificarDeshabilitado {
    opacity: 0.3;
    pointer-events: none;
  }

  .div-opcionesActions {
    /*
      width: 87%;
      bottom: 10px;
      position: absolute;
      */
    margin-top: 40px;
    margin-bottom: 15px;
    margin-right: 30px;
  }

  .div-separador {
    width: 94%;
    bottom: 45px;
    position: absolute;
  }

  .div-cabeceraFormularioEdicionDePedidoPopupContenido {
    margin-left: 22px;
    margin-top: 10px;
  }

  .div-rectanguloPedidoDivido {
    background-color: #ff3b30;
    border-radius: 3px;
    width: 30px;
    height: 19px;
    text-align: center;
  }

  .div-rectanguloPedidoDivido span {
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
  }

  .div-operacionesFormularioEdicionDePedidoPopupContenido {
    /* margin-left: 22px; */
    margin-top: 10px;
  }

  .Prioridad {
    color: var(--his-steel-blue);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.2px;
    line-height: 17px;
    text-align: center;
    margin-top: 6px;
    background-color: rgb(122 134 154 / 20%);
    border-radius: 14px;
    max-width: 30px;
    min-width: 30px;
    float: right;
  }

  .PrioridadPlanificado {
    position: absolute;
    top: 0;
    right: -6px;
  }

  .PrioridadNoPlanificado {
    margin-top: 2px;
  }

  .div-tituloDetallesDelPedido {
    margin-top: 15px;
    margin-right: 20px;
    background: var(--his-blueberry-mist);
  }

  .row-contenidoTarjeta {
    display: flex;
  }

  .btn-edicion {
    position: absolute;
    top: 35px;
    right: -6px;
  }

  .col-btnEdicion-planificados {
    position: relative;
  }

  .col-btnEdicion-sinPlanificar {
    position: relative;
    padding-left: 7px;
    padding-top: 5px;
  }

  .div-elementoTarjetaLineaDeshabilitada {
    opacity: 0.3;
    pointer-events: none;
  }

  .img-elementoParaMoverTarjeta {
    float: right;
    margin-right: 7px;
  }

  .div-logoHispatecDerecha {
    max-width: 250px;
    margin-top: 18px;
    border-left: 1px solid rgb(151 151 151 / 30%);
    text-align: end;
    padding-right: 15px;
  }

  .row-cabeceraFrm {
    height: 95px;
  }

  .div-contenidoFrmPopup {
    max-height: 100%;

    /* height: 60vh; */
    overflow-y: auto;
  }

  .div-selectorDeLineaDeProduccionParaCambioDeLinea {
    margin-left: -20px;
  }

  .div-operacionSobrePlanificacion {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .div-stepperDividirPedido {
    margin-top: 7px;
  }

  .img-logoHispatec {
    padding-left: 45px;
  }

  .componenteDatosAdjuntosEntidad {
    width: 96%;
  }
}

.content-card {
  width: 100%;

  &__title {
    background-color: #f0f8ff;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div:first-child {
      color: var(--his-oliva);
      font-size: 14px;
      font-weight: 400;
      display: -webkit-flex;
      white-space: normal;
      -webkit-line-clamp: 1;
      -webkit-align-items: center;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: top;

      img {
        margin-right: 8px;
      }

      span {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    &--action {
      border-left: 1px solid #dde9f4;
      height: 34px;

      img {
        padding: 10px 16px;
        margin: 0 !important;
      }
    }
  }

  &__title-left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &__title-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  &__info {
    background-color: #fff;
    border-radius: 0 0 6px 6px;

    .card-info-content-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &__title {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        color: var(--his-navy-night);
        font-weight: 600;
        font-size: 14px;
      }

      &__after {
        display: flex;
        align-items: center;

        .badge {
          &.color-gray {
            --f7-badge-text-color: var(--his-oliva);
            --f7-badge-bg-color: #e8f0f8;
          }
        }

        img {
          margin-left: 15px;
          width: 28px;
          height: 28px;
        }
      }
    }

    .card-info-content-subtitle {
      display: -webkit-box;
      white-space: normal;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-top: 10px;
      color: var(--his-ash-gray);
      font-size: 500;
      font-size: 14px;
    }

    .card-info-content-text {
      color: var(--his-plum-shadow);
      font-size: 13px;
      font-weight: 400;
    }

    .card-info-content-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;

      &__ref {
        color: var(--his-plum-shadow);
        font-size: 13px;
        font-weight: 500;
      }

      &__items {
        display: flex;
        align-items: center;

        div {
          display: flex;
          align-items: center;

          span {
            color: var(--his-steel-blue);
            font-size: 16px;
            font-weight: 600;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

.popup-distribuirPlanificacion {
  --f7-navbar-height: 44px;
  --f7-navbar-title-font-size: 16px;
  --f7-navbar-bg-color: var(--his-silver);
  --f7-popup-tablet-height: 90vh !important;

  .navbar ~ .page-content {
    padding-top: var(--f7-page-navbar-offset);
  }

  .content-button {
    display: flex;
    justify-content: space-between;
    --f7-button-font-size: 16px;
  }
}

.popupEdicionPedido-popup {
  --f7-navbar-height: 44px;
  --f7-navbar-title-font-size: 16px;
  --f7-navbar-bg-color: var(--his-silver);
  --f7-popup-tablet-height: 90vh !important;

  .navbar ~ .page-content {
    padding-top: var(--f7-page-navbar-offset);
  }

  .content-popup {
    background-color: #eaf2fa;

    .content-card {
      &__title {
        padding: 8px 0;
        background-color: var(--his-silver);
      }

      .card-info-content-footer {
        &__items {
          div {
            span {
              margin-left: 10px;
            }
          }
        }
      }
    }

    .content-accordion {
      --f7-list-item-title-text-color: var(--his-steel-blue);
      --f7-list-chevron-icon-color: var(--his-steel-blue);

      .accordion-item {
        >a {
          .item-content {
            background-color: #fafbfc;
            border-bottom: 1px solid #ebecf0;
          }
        }
      }

      .content-detail-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .content-stepper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          span {
            color: var(--his-steel-blue);
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }

    .content-button {
      display: flex;
      justify-content: space-between;
      --f7-button-font-size: 16px;
    }
  }
}

.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  align-content: stretch;
}

.LineasPedidoVentaOrdenYParteProduccion-popup {
  @media (min-width: 630px) {
    height: 690px !important;
    top: 46% !important;
  }
}
</style>
